import React, { useState, useEffect } from 'react';

const BrandOwnerBit = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        const element = document.getElementById('brand-owner-section');
        if (element) observer.observe(element);

        return () => observer.disconnect();
    }, []);

    const founders = [
        {
            id: 1,
            name: "Shubham Lathiya",
            title: "Co-Founder & CEO",
            tagline: "Passionate about creating products that people trust",
            image: "https://ik.imagekit.io/kromaic/kromaic/Co-Founder/WhatsApp%20Image%202026-06-02%20at%2010.30.33%20PM.jpeg",
            bio: "Driven by a vision to build high-quality personal care products, Shubham focuses on creating customer-centric solutions that combine innovation, quality, and affordability. As a young entrepreneur, he is committed to building a brand that delivers real value and trust.",
            quote: "Every great brand starts with a simple mission—to make a positive difference in people's everyday lives.",
            achievements: [
                "Visionary Entrepreneur",
                "Customer-First Mindset",
                "Building KROMAIC"
            ]
        },
        {
            id: 2,
            name: "Riyank Vaghani",
            title: "Co-Founder & CTO",
            tagline: "Transforming ideas into meaningful digital experiences",
            image: "https://ik.imagekit.io/kromaic/kromaic/Co-Founder/WhatsApp%20Image%202026-06-02%20at%2010.23.55%20PM.jpeg",
            bio: "Riyank is passionate about technology, innovation, and problem-solving. He works on building the digital foundation of KROMAIC while ensuring customers enjoy a seamless and engaging experience. His focus is on continuous improvement and long-term growth.",
            quote: "Innovation begins when curiosity meets determination.",
            achievements: [
                "Technology Enthusiast",
                "Innovation Driven",
                "Co-Building KROMAIC"
            ]
        }
    ];

    return (
        <div id="brand-owner-section" className="brand-owner-section">
            <div className="container-luxury">
                {/* Section Header */}
                <div className={`text-center mb-16 transition-all duration-1000 transform ${
                    isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                }`}>
                    <span className="text-champagne text-sm uppercase tracking-wider font-medium mb-3 block">
                        The Visionaries
                    </span>
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-light text-charcoal mb-4">
                        Meet the <span className="text-champagne italic">Founders</span>
                    </h2>
                    <div className="w-20 h-px bg-champagne/30 mx-auto my-6"></div>
                    <p className="text-lg text-charcoal/60 max-w-2xl mx-auto">
                        Three visionaries united by a passion for redefining luxury skincare through science, artistry, and integrity
                    </p>
                </div>

                {/* Founders Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
                    {founders.map((founder, index) => (
                        <div
                            key={founder.id}
                            className={`group transition-all duration-700 delay-${index * 150} transform ${
                                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
                            }`}
                        >
                            <div className="relative overflow-hidden rounded-2xl bg-white shadow-soft hover:shadow-elevated transition-all duration-500">
                                {/* Image Container */}
                                <div className="relative overflow-hidden aspect-square">
                                    <img
                                        src={founder.image}
                                        alt={founder.name}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-charcoal/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                        <div className="absolute bottom-6 left-6 right-6">
                                            <p className="text-white text-sm italic">"{founder.quote}"</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="p-6 text-center">
                                    {/* Name */}
                                    <h3 className="text-2xl font-heading font-medium text-charcoal mb-2">
                                        {founder.name}
                                    </h3>

                                    {/* Title */}
                                    <p className="text-champagne font-medium text-sm uppercase tracking-wider mb-3">
                                        {founder.title}
                                    </p>

                                    {/* Tagline */}
                                    <p className="text-charcoal/70 text-sm italic mb-4">
                                        "{founder.tagline}"
                                    </p>

                                    {/* Bio */}
                                    <p className="text-charcoal/60 text-sm leading-relaxed mb-5">
                                        {founder.bio}
                                    </p>

                                    {/* Divider */}
                                    <div className="w-12 h-px bg-champagne/30 mx-auto my-4"></div>

                                    {/* Social Links */}
                                    {/*<div className="flex justify-center gap-4">*/}
                                    {/*    <a*/}
                                    {/*        href={founder.socialLinks.linkedin}*/}
                                    {/*        className="text-charcoal/40 hover:text-champagne transition-colors duration-300"*/}
                                    {/*        target="_blank"*/}
                                    {/*        rel="noopener noreferrer"*/}
                                    {/*    >*/}
                                    {/*        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">*/}
                                    {/*            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>*/}
                                    {/*        </svg>*/}
                                    {/*    </a>*/}
                                    {/*    <a*/}
                                    {/*        href={founder.socialLinks.instagram}*/}
                                    {/*        className="text-charcoal/40 hover:text-champagne transition-colors duration-300"*/}
                                    {/*        target="_blank"*/}
                                    {/*        rel="noopener noreferrer"*/}
                                    {/*    >*/}
                                    {/*        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">*/}
                                    {/*            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM12 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.441s.645 1.44 1.441 1.44c.795 0 1.44-.645 1.44-1.44s-.645-1.441-1.44-1.441z"/>*/}
                                    {/*        </svg>*/}
                                    {/*    </a>*/}
                                    {/*    <a*/}
                                    {/*        href={founder.socialLinks.twitter}*/}
                                    {/*        className="text-charcoal/40 hover:text-champagne transition-colors duration-300"*/}
                                    {/*        target="_blank"*/}
                                    {/*        rel="noopener noreferrer"*/}
                                    {/*    >*/}
                                    {/*        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">*/}
                                    {/*            <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0021.297-4.429 14.012 14.012 0 001.954-7.233c0-.214-.005-.428-.015-.642A9.935 9.935 0 0024 4.59z"/>*/}
                                    {/*        </svg>*/}
                                    {/*    </a>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Brand Values Section */}
                {/*<div className={`mt-20 pt-10 border-t border-nude/30 transition-all duration-1000 delay-300 transform ${*/}
                {/*    isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'*/}
                {/*}`}>*/}
                {/*    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">*/}
                {/*        <div className="text-center">*/}
                {/*            <div className="w-16 h-16 bg-champagne/10 rounded-full flex items-center justify-center mx-auto mb-4">*/}
                {/*                <svg className="w-8 h-8 text-champagne" fill="none" stroke="currentColor" viewBox="0 0 24 24">*/}
                {/*                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>*/}
                {/*                </svg>*/}
                {/*            </div>*/}
                {/*            <h4 className="text-lg font-heading font-medium text-charcoal mb-2">Clean Promise</h4>*/}
                {/*            <p className="text-charcoal/60 text-sm">Vegan, cruelty-free, and formulated without 2,000+ harmful ingredients</p>*/}
                {/*        </div>*/}
                {/*        <div className="text-center">*/}
                {/*            <div className="w-16 h-16 bg-champagne/10 rounded-full flex items-center justify-center mx-auto mb-4">*/}
                {/*                <svg className="w-8 h-8 text-champagne" fill="none" stroke="currentColor" viewBox="0 0 24 24">*/}
                {/*                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3.636 3.636a9 9 0 0116.728 0M5.343 5.343a7 7 0 0113.314 0M7.05 7.05a5 5 0 0110.9 0M8.757 8.757a3 3 0 016.486 0"/>*/}
                {/*                </svg>*/}
                {/*            </div>*/}
                {/*            <h4 className="text-lg font-heading font-medium text-charcoal mb-2">Scientifically Proven</h4>*/}
                {/*            <p className="text-charcoal/60 text-sm">Clinical testing and dermatologist-approved formulations</p>*/}
                {/*        </div>*/}
                {/*        <div className="text-center">*/}
                {/*            <div className="w-16 h-16 bg-champagne/10 rounded-full flex items-center justify-center mx-auto mb-4">*/}
                {/*                <svg className="w-8 h-8 text-champagne" fill="none" stroke="currentColor" viewBox="0 0 24 24">*/}
                {/*                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>*/}
                {/*                </svg>*/}
                {/*            </div>*/}
                {/*            <h4 className="text-lg font-heading font-medium text-charcoal mb-2">Sustainable Luxury</h4>*/}
                {/*            <p className="text-charcoal/60 text-sm">Eco-conscious packaging and carbon-neutral operations</p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

            <style jsx>{`
                .brand-owner-section {
                    padding: 5rem 0;
                    background: linear-gradient(135deg, #FDFBF7 0%, #F5F0E8 100%);
                    position: relative;
                    overflow: hidden;
                }
                
                .brand-owner-section::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 1px;
                    background: linear-gradient(90deg, transparent, #D4C5B0, transparent);
                }
                
                @media (max-width: 768px) {
                    .brand-owner-section {
                        padding: 3rem 0;
                    }
                }
            `}</style>
        </div>
    );
};

export default BrandOwnerBit;